/**
 * @fileoverview Data operations and helpers for advisors
 *
 * Schema:
 *   avatar: string
 *   name: string
 *   title: string
 *   present: boolean
 *   joined: boolean
 *   role: string
 */

export default function Advisor(...data) {
  let advisor = {
    avatar: '',
    name: '',
    title: '',
    present: false,
    joined: false,
    role: 'advisor',
    phoneNumber: ''
  }

  Object.assign(advisor, ...data)

  return advisor
}
